import { motion } from "framer-motion";
import { TypingText } from "../useful/CustomText";

import styles from "../Home";
import { fadeIn, staggerContainer } from "../useful/motion";

const OurSolution = () => (
  <section className={`${styles.paddings} relative z-7 mt-10`}>
    <div className="gradient-05 z-0" />
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto ${styles.flexCenter} flex-col`}
    >
      <TypingText title="OUR SOLUTION" textStyles="text-center" />
      <div className="infos2">
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="mt-[10px] sm:text-[32px] text-[20px] singleinfo text-style"
          style={{ flex: "2" }}
        >
          <TypingText title="A Cadmium Catcher LBP" textStyles="question" />
          Our <i>E. Coli</i> are engineered to produce two key proteins: a{" "}
          <b>mucus-binding protein</b> called <b>SpaC</b> and a{" "}
          <b>cadmium-specific binding protein</b> known as <b>EC20</b>. <br />
          The mucus-binding protein will implant our probiotic into the
          intestine and our cadmium binding protein will allow it to collect any
          cadmium ions present there. As the mucus naturally turns over, our
          probiotic will eventually exit the body, cleansing it of cadmium.
          <br />
          As a safety precaution, the production of the SpaC protein is halted
          once it enters the body, and the protein naturally degrades over time,
          allowing the bacteria to be released. To prevent environmental spread
          and genetic exchange with other organisms, the bacteria are
          auxotrophic and have specific genetic mutations that{" "}
          <b>prevent horizontal gene transfer</b>.
        </motion.p>
      </div>
      <motion.p
        variants={fadeIn("up", "tween", 0.2, 1)}
        className="sm:text-[32px] text-[20px] visitotherpage relative"
      >
        <a href="../epfl/description">See more in our description.</a>
      </motion.p>
    </motion.div>
  </section>
);
export default OurSolution;
